import { NavContextType } from "src/components/navigation/NavContext"
import { GuestShellLayout } from "src/components/ui/GuestShellLayout";
import { Icons } from "src/components/ui/Icons"

import ForgotPassword from "src/screens/auth/ForgotPassword";
import ResetPassword from "src/screens/auth/ResetPassword";
import SignIn from "src/screens/auth/SignIn";
import SignUpType from "src/screens/auth/SignUpType";
import TalentSignup from "src/screens/auth/TalentSignUp";
import VenueSignUp from "src/screens/auth/VenueSignUp";

export const GuestRoutes = ():NavContextType => ({
    routes: [
        {
            path: '/',
            element: <GuestShellLayout />,
            breadcrumb: 'Layout',
            children: [
                { index: true, element: <SignIn />, breadcrumb: 'Sign In' },
                { path: "sign-in", element: <SignIn />, breadcrumb: 'Sign Up' },
                { path: "sign-up", element: <SignUpType />, breadcrumb: 'Sign Up' },
                { path: "talent-sign-up", element: <TalentSignup />, breadcrumb: 'Talent Sign Up' },
                { path: "venue-sign-up", element: <VenueSignUp />, breadcrumb: 'Venue Sign Up' },
                { path: "forgot-password", element: <ForgotPassword />, breadcrumb: 'Forgot Password' },
                { path: "reset-password", element: <ResetPassword />, breadcrumb: 'Reset Password' },
                { path: "*", element: <SignIn />, breadcrumb: 'Sign In' }
            ]
        }
    ],
    menu: [ 
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        }
    ],
    mobile: [
        
    ]
})
